import axios from 'axios'
export default {
    state: {
        users: {},
        user: {
            id: 0,
            email: '',
            name: '',
            surname: '',
            thirdname: '',
            phone: '',
            position: ''
        },
        users_filter: {
            name: '',
            offset: 0,
            limit: 30,
            count_users: 0
        },
    },
    getters: {
        users: (state) => state.users,
        user: (state) => state.user,
        count_users: (state) => state.users_filter.count_users
    },
    mutations: {
        SET_USERS(state, playload) {
            state.users = playload
        },
        SET_USER(state, playload) {
            state.user = playload
        },
        SET_USER_FIELD(state, playload) {
            state.user[playload.field] = playload.value
        },
        SET_USERS_FILTER(state, playload) {
            state.users_filter[playload.field] = playload.value
        }
    },
    actions: {
        GET__USERS({commit, state}) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            axios.post(process.env.VUE_APP_API_URL + '/api/users/list', {
                name: state.users_filter.name,
                offset: state.users_filter.offset *  state.users_filter.limit,
                limit: state.users_filter.limit,

            })
                .then(response => {
                    commit('SET_USERS', response.data.data)
                    commit('SET_USERS_FILTER', {field: 'count_users', value: response.data.count})
                })
                .catch(error => {
                    commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                });
        },
        async GET__USER({commit, state}, data) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            await axios.get(process.env.VUE_APP_API_URL + '/api/users/' + data)
                .then(response => {
                    commit('SET_USER', response.data.data)
                })
                .catch(error => {
                    commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                });
        },
        async UPDATE__USER({commit, state, dispatch}) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
            await axios.patch(process.env.VUE_APP_API_URL + '/api/users/' + state.user.id, state.user)
                .then(response => {
                    dispatch('GET__USERS')
                })
                .catch(error => {
                    commit('SET_CUSTOM_ERROR', {state: true, text: error.response.data.data})
                });
        }
    }
}